import { ViewName } from "../../../types";
import { VIEWS } from "../../../constants/views";

interface UseNavigationProps {
  currentView: ViewName;
  userId: string | null;
  setCurrentView: (view: ViewName) => void;
}

export const useNavigation = ({
  currentView,
  userId,
  setCurrentView,
}: UseNavigationProps) => {
  const handleBack = (): void => {
    let prevView: ViewName | "" = "";

    // Determine current flow based on route and view
    const isDistributorFlow =
      window.location.pathname.startsWith("/distributor") ||
      currentView === "distributor-login" ||
      currentView === "distributor-welcome";

    if (isDistributorFlow) {
      switch (currentView) {
        case "distributor-login":
          prevView = "home";
          break;
        case "distributor-code-handler":
          prevView = "distributor-login";
          break;
        case "distributor-successful":
          prevView = "distributor-login";
          break;
        case "distributor-welcome":
          prevView = "distributor-login";
          break;
        case "user-info":
          prevView = "distributor-welcome";
          break;
        case "edit-profile":
          const storedEditProfilePrevViewDistributor = sessionStorage.getItem(
            "editProfilePrevView"
          );
          if (storedEditProfilePrevViewDistributor) {
            prevView = storedEditProfilePrevViewDistributor as ViewName;
            sessionStorage.removeItem("editProfilePrevView");
          } else {
            prevView = "distributor-welcome";
          }
          break;
        case "selfie":
          window.OrboSmartCapture?.stop();
          prevView = "user-info";
          break;
        case "scores":
          prevView = "selfie";
          break;
        case "recommendations":
          prevView = "scores";
          break;
        case "feedback":
          prevView = "scores";
          break;
        case "DistributorUserDetails":
          prevView = "distributor-welcome";
          break;
        case "MoreUserDetails":
          prevView = "DistributorUserDetails";
          break;
        case VIEWS.DISTRIBUTOR_DEACTIVATED_USER:
          const storedDeactivatedUsersPrevView = sessionStorage.getItem('deactivatedUsersPrevView');
          if (storedDeactivatedUsersPrevView) {
            prevView = storedDeactivatedUsersPrevView as ViewName;
            sessionStorage.removeItem('deactivatedUsersPrevView');
          } else {
            prevView = "distributor-welcome";
          }
          break;
        case "Welcome":
          prevView = "selfie";
          break;
        case "privacy-policy":
          const storedPrevViewDistributor = sessionStorage.getItem(
            "privacyPolicyPrevView"
          );
          if (
            storedPrevViewDistributor &&
            storedPrevViewDistributor.startsWith("signup-")
          ) {
            prevView = "signup";
            sessionStorage.setItem(
              "signupStep",
              storedPrevViewDistributor.split("-")[1]
            );
          } else if (
            storedPrevViewDistributor &&
            [
              "home",
              "contact",
              "distributor-login",
              "Welcome",
              "user-info",
            ].includes(storedPrevViewDistributor as ViewName)
          ) {
            prevView = storedPrevViewDistributor as ViewName;
          } else {
            prevView = "distributor-login";
          }

          break;
      }
    } else {
      switch (currentView) {
        case "contact":
          prevView = "home";
          break;
        case "verify-otp":
          prevView = "contact";
          break;
        case "forgot-password":
          prevView = "contact";
          break;
        case "signup":
          prevView = "home";
          break;
        case "user-info":
          prevView = !userId ? "contact" : "Welcome";
          break;
        case "edit-profile":
          const storedEditProfilePrevView = sessionStorage.getItem(
            "editProfilePrevView"
          );
          if (storedEditProfilePrevView) {
            prevView = storedEditProfilePrevView as ViewName;
            sessionStorage.removeItem("editProfilePrevView");
          } else {
            prevView = "Welcome";
          }
          break;
        case "selfie":
          window.OrboSmartCapture?.stop();
          prevView = "user-info";
          break;
        case "scores":
          prevView = "selfie";
          break;
        case "feedback":
          prevView = "scores";
          break;
        case "Welcome":
          prevView = userId ? "home" : "contact";
          break;
        case "UserDetails":
          prevView = "Welcome";
          break;
        case "privacy-policy":
          const storedPrevView = sessionStorage.getItem("privacyPolicyPrevView");

          if (storedPrevView && storedPrevView.startsWith("signup-")) {
            prevView = "signup";
            sessionStorage.setItem("signupStep", storedPrevView.split("-")[1]);
          } else if (
            storedPrevView &&
            ["home", "contact", "distributor-login", "Welcome", "user-info"].includes(
              storedPrevView as ViewName
            )
          ) {
            prevView = storedPrevView as ViewName;
          } else {
            prevView = "home";
          }

          break;
        case "MoreUserDetails":
          prevView = "Welcome";
          break;
      }
    }

    if (prevView !== "") {
      if (currentView === "privacy-policy") {
        sessionStorage.removeItem("privacyPolicyPrevView");
      }
      setCurrentView(prevView);
    }
  };

  return { handleBack };
};
